import { Calendar } from 'lucide-react';
import { createElement, lazy } from 'react';
import type { FeatureModule } from '@/app/contract';
import { APP_ROUTES, agendaPath, calendarPath } from '@/app/paths';
import { registerNamespace } from '@/i18n';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';

registerNamespace('calendar', { en, 'zh-Hans': zh });

const LazyCalendarRoute = lazy(() => import('./routes').then(m => ({ default: m.CalendarRoute })));
const LazyAgendaRoute = lazy(() => import('./routes').then(m => ({ default: m.AgendaRoute })));
const LazyEventRoute = lazy(() => import('./routes').then(m => ({ default: m.EventRoute })));
const LazyNumberRoute = lazy(() => import('./routes').then(m => ({ default: m.NumberRoute })));
// The shell also suspends its route wrapper; pass real components across the contract.
const CalendarRoute = () => createElement(LazyCalendarRoute);
const AgendaRoute = () => createElement(LazyAgendaRoute);
const EventRoute = () => createElement(LazyEventRoute);
const NumberRoute = () => createElement(LazyNumberRoute);
const feature: FeatureModule = {
  id: 'calendar',
  section: { id: 'calendar', titleKey: 'calendar:title', icon: Calendar },
  routes: [
    { ...APP_ROUTES.calendar, component: CalendarRoute },
    { ...APP_ROUTES.agenda, component: AgendaRoute },
    { ...APP_ROUTES.event, component: EventRoute },
    { ...APP_ROUTES.eventOccurrence, component: EventRoute },
    { ...APP_ROUTES.calendarNumber, component: NumberRoute },
  ],
  commands: [
    { id: 'calendar.today', titleKey: 'calendar:go_today', icon: Calendar, run: nav => nav.open(calendarPath()) },
    { id: 'calendar.newEvent', titleKey: 'calendar:new_event', icon: Calendar, run: nav => nav.open(calendarPath({ create: 'event' })) },
    { id: 'calendar.refresh', titleKey: 'calendar:refresh', icon: Calendar, shortcut: 'mod+shift+r', run: nav => { nav.open(`${calendarPath()}?refresh=${Date.now()}`); } },
    ...(['year', 'month', 'week', 'day'] as const).map(mode => ({ id: `calendar.view.${mode}`, titleKey: `calendar:command_${mode}`, run: (nav: Parameters<NonNullable<FeatureModule['commands']>[number]['run']>[0]) => nav.open(calendarPath({ mode })) })),
    { id: 'calendar.agenda', titleKey: 'calendar:calendar_entries', run: nav => nav.open(agendaPath()) },
  ],
};

export default feature;

export { ItemCalendarSheet, type ItemCalendarSheetProps } from './public';
